import { defaultInputFieldColor, defaultInputFieldBorderColor, } from '../defaults';
export const extractInputFieldStyles = (customStyle) => {
    return {
        color: customStyle.color || defaultInputFieldColor,
        borderColor: customStyle.borderColor || defaultInputFieldBorderColor,
    };
};
//# sourceMappingURL=extract-input-field-styles.js.map